/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProhibitedCategorySearchRequest } from '../models/ProhibitedCategorySearchRequest';
import type { ProhibitedCategorySearchResponse } from '../models/ProhibitedCategorySearchResponse';
import type { ProhibitedCategoryUpsertRequest } from '../models/ProhibitedCategoryUpsertRequest';
import type { ProhibitedItemSearchRequest } from '../models/ProhibitedItemSearchRequest';
import type { ProhibitedItemSearchResponse } from '../models/ProhibitedItemSearchResponse';
import type { ProhibitedItemUpsertRequest } from '../models/ProhibitedItemUpsertRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProhibitedControllerService {
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static upsertProhibitedItems(
        requestBody: ProhibitedItemUpsertRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/prohibited/item',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ProhibitedItemSearchResponse OK
     * @throws ApiError
     */
    public static getProhibitedItems(
        requestBody: ProhibitedItemSearchRequest,
    ): CancelablePromise<ProhibitedItemSearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/prohibited/item',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static upsertProhibitedCategory(
        requestBody: ProhibitedCategoryUpsertRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/prohibited/category',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ProhibitedCategorySearchResponse OK
     * @throws ApiError
     */
    public static getProhibitedCategories(
        requestBody: ProhibitedCategorySearchRequest,
    ): CancelablePromise<ProhibitedCategorySearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/prohibited/category',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param jans
     * @returns ProhibitedItemSearchResponse OK
     * @throws ApiError
     */
    public static getProhibitedItemsInfo(
        jans: Array<string>,
    ): CancelablePromise<ProhibitedItemSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/prohibited/items-info',
            query: {
                'jans': jans,
            },
        });
    }
}
